import React from 'react';

import Button from '../../../../../Table/Row/Button';

export default function Buttons({ isVisible, onCancelClick, onSaveClick }) {
  if (!isVisible) {
    return null;
  }

  return (
    <div className="flex gap-5">
      <Button onClick={onSaveClick} label="Save" isVisible />

      <button
        type="button"
        className="underline bg-transparent border-none text-blue-500 hover:text-blue-700 focus:outline-none dark:text-blue-300 dark:hover:text-blue-500"
        onClick={onCancelClick}
      >
        Cancel
      </button>
    </div>
  );
}
